module.exports = __webpack_public_path__ + "static/plan-pp.51fc8ef4.svg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/plans/plan-pp.svg
// module id = 1202
// module chunks = 0 1 2 3